import React, { useEffect } from 'react';
import { useBeneficiaryStore, useRateStore } from '../../../../store';
import Modal from '../../../base/modal';
import AddBeneficiary from '../../beneficiary/shared/add-beneficiary';
import toast from 'react-hot-toast';

const AddBeneficiaryModal: React.FC<{
  isModalOpen: boolean;
  toggleModal: () => void;
}> = ({ isModalOpen, toggleModal }) => {
  const { getActiveCountries } = useRateStore();
  const {
    step,
    goNext,
    prev,
    saveBeneficiary,
    loading: isLoading,
    resetBeneficiaryPayload,
    resetStep,
  } = useBeneficiaryStore();

  const addBeneficiary = async () => {
    await getActiveCountries();
    const response = await saveBeneficiary();
    if (response && response.isSuccess) {
      toggleModal();
      toast.success('Beneficiary created successfully.');
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      resetBeneficiaryPayload();
      resetStep();
    }
  }, [isModalOpen]);

  return (
    <Modal
      isOpen={isModalOpen}
      toggleModal={toggleModal}
      width="w-[500px] h-fit"
    >
      <div className="flex flex-col gap-8">
        <p className="text-xl font-bold leading-7">Add New Beneficiary</p>

        <AddBeneficiary
          caller="modal"
          step={step}
          goNext={goNext}
          prev={prev}
          loading={isLoading}
          addBeneficiary={addBeneficiary}
        />
      </div>
    </Modal>
  );
};

export default AddBeneficiaryModal;
